import React, { useState } from 'react';
import { Marker } from 'react-mapbox-gl';
import styled from 'styled-components';

import { useEventRoute, useToggle } from '../../hooks';
import { Event, MapboxMap } from '../../interfaces';
import { getOriginalEventCoords } from '../../utils';
import { isNil } from '../../utils';
import { Button, Heading, InternalOnly, MapBox, RippleDot } from '../atoms';
import { RoutesLayer } from '../map/RoutesLayer';
import { colorScheme } from '../../theme';

interface Props {
  event: Event;
}

export function EventMap(props: Props) {
  const { event } = props;
  const { lon, lat } = getOriginalEventCoords(event);
  const { heading } = event?.metadata ?? {};
  const center = [lon, lat]; // TS gets confused with [number,number] and number[]
  const [map, setMap] = useState<MapboxMap>(null);
  const [showRoute, toggleRoute] = useToggle(false);
  const route = useEventRoute(event);

  const onMapReady = (loadedMap: MapboxMap): void => {
    setMap(loadedMap);
  };

  if (!event) {
    return null;
  }

  return (
    <MapBox onStyleLoad={onMapReady} containerStyle={{ width: '100%', minHeight: '200px' }} center={center} zoom={[16]}>
      <InternalOnly>
        <ButtonContainer>
          <Button variant={showRoute ? 'primary' : 'secondary'} onClick={toggleRoute} size="sm" disabled={isNil(route)}>
            Show route
          </Button>
        </ButtonContainer>
      </InternalOnly>

      <Marker coordinates={center} anchor="center">
        <>
          <RippleDot color={colorScheme.brand} />
          {heading && <Heading heading={heading} />}
        </>
      </Marker>

      <InternalOnly>{showRoute && map && <RoutesLayer map={map} key="routeLayer" routeId={route?.id} />}</InternalOnly>
    </MapBox>
  );
}

const ButtonContainer = styled.div`
  position: absolute;
  display: flex;
  gap: 4px;
  bottom: 12px;
  left: 12px;
  z-index: 10;
`;
